import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import ProgressBar from 'common/components/ProgressBar';
import styles from './styles.module.scss';

const RequestPending = ({
                                         progress
                                       }) => {

  return (
    <div className={styles.pendingContainer} dir='ltr'>
      <div className={styles.serverRequestModalContent}>
        <div className={styles.progressBarContainer}>
          <ProgressBar progress={progress}/>
        </div>
        <p className={styles.statePending}>בבקשה המתינו לסיום הפעולה</p>
      </div>
    </div>
  );
};

RequestPending.propTypes = {
  isOpen: PropTypes.bool,
  close: PropTypes.func,
  progress: PropTypes.number
};

const AnimatedProgress = ({onFinish}) => {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    animateProgressBar();
    if (onFinish) onFinish();
  }, []);

  const animateProgressBar = () => {
    const progressGrowSize = 10;
    const delayGrowFactor = 1.75;
    let delay = 500;
    let fakeProgress = 0;
    let timerId = setTimeout(function request() {
      fakeProgress += progressGrowSize;
      setProgress(fakeProgress);
      if (fakeProgress < 100) {
        delay *= delayGrowFactor;
        timerId = setTimeout(request, delay);
      } else {
        clearTimeout(timerId);
      }
    }, delay);
  };

  return (
    <RequestPending
      progress={progress}
    />
  );
};

AnimatedProgress.propTypes = {};

export default AnimatedProgress;
